<div class="relative flex min-h-screen items-center justify-center bg-slate-900/5 px-4 py-12">
  <div
    class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(59,130,246,0.15),_transparent_45%)]"
  ></div>
  <div
    class="relative w-full max-w-4xl overflow-hidden rounded-[32px] bg-white/90 p-8 shadow-2xl backdrop-blur-md md:p-12 lg:p-16"
  >
    <div class="absolute top-10 -right-16 h-48 w-48 rounded-full bg-blue-100/60 blur-3xl"></div>
    <div class="absolute -bottom-16 -left-24 h-56 w-56 rounded-full bg-rose-100/70 blur-3xl"></div>

    <div class="relative z-10 flex flex-col gap-10 md:flex-row md:items-center">
      <div class="flex flex-1 flex-col items-center text-center md:items-start md:text-left">
        <div
          class="mb-8 flex items-center gap-4 rounded-2xl bg-slate-50 px-4 py-3 text-sm text-slate-500"
        >
          <span
            class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-rose-100 text-rose-500"
          >
            <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01M12 5c-1.534 0-3.06.61-4.243 1.757A6 6 0 1018 12h-6"
              ></path>
            </svg>
          </span>
          <span>Security policy prevented this action</span>
        </div>

        <h1 class="mb-4 text-4xl font-semibold tracking-tight text-slate-900 md:text-5xl">
          Access not granted
        </h1>
        <p class="text-lg leading-relaxed text-slate-500">
          Your account currently lacks the permissions required to view this resource. This may be
          because the request is restricted to specific roles or the link has expired.
        </p>

        <ul class="mt-8 space-y-3 text-left text-base text-slate-600">
          <li class="flex items-start gap-3">
            <span class="mt-1 h-2 w-2 rounded-full bg-blue-500"></span>
            Confirm you are logged in with the correct role.
          </li>
          <li class="flex items-start gap-3">
            <span class="mt-1 h-2 w-2 rounded-full bg-blue-500"></span>
            Request access from your workspace administrator.
          </li>
          <li class="flex items-start gap-3">
            <span class="mt-1 h-2 w-2 rounded-full bg-blue-500"></span>
            Try refreshing or navigating back to continue browsing.
          </li>
        </ul>

        <div class="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:items-center">
          <button
            (click)="goBack()"
            class="inline-flex w-full items-center justify-center rounded-xl bg-blue-600 px-6 py-3 font-medium text-white shadow-lg shadow-blue-600/30 transition-all duration-200 hover:-translate-y-0.5 hover:bg-blue-700 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none sm:w-auto"
          >
            <svg class="mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>
            Go Back
          </button>

          @if (isAdmin) {
          <button
            (click)="goToLogin()"
            class="inline-flex w-full items-center justify-center rounded-xl border border-slate-200 px-6 py-3 font-medium text-slate-700 transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none sm:w-auto"
          >
            Logout
          </button>
          }
        </div>

        <p class="mt-6 text-sm text-slate-500">Need help? Reach out to your administrator.</p>
      </div>

      <div class="flex flex-1 justify-center">
        <div
          class="relative w-full max-w-sm rounded-3xl bg-gradient-to-br from-blue-500 to-indigo-500 p-1 shadow-xl"
        >
          <div class="rounded-[26px] bg-slate-900/80 p-8 text-slate-100 backdrop-blur">
            <p class="text-sm tracking-[0.3em] text-blue-200 uppercase">Status</p>
            <p class="mt-3 text-3xl font-semibold text-white">Restricted</p>
            <div class="mt-6 space-y-4 text-sm text-blue-100">
              <div class="flex items-center justify-between">
                <span>Reason</span>
                <span class="font-medium text-white">Role mismatch</span>
              </div>
              <div class="flex items-center justify-between">
                <span>Error Message</span>
                <span class="font-mono text-base text-white">Unauthorized Access</span>
              </div>

              <div class="flex items-center justify-between">
                <span>Last attempt</span>
                <span class="font-medium text-white">Just now</span>
              </div>
            </div>
            <div class="mt-8 rounded-2xl bg-white/10 p-4 text-sm leading-relaxed text-blue-100">
              Our security systems blocked this request to keep your workspace safe. If you believe
              this is an error, please confirm with your admin.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
